import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ParameterName, Parameter } from '../models/parameter';

@Injectable()
export class ParametersService {

  dashboardRefreshInterval: number = environment.defaultDashboardRefreshInterval;

  PARAMETERS_API_URL: string = environment.serverUrl + 'api/1/settings';

  constructor(private http: HttpClient) { }

  /**
   * Called on application init
   */
  getDashboardRefreshInterval(): Promise<any> {
    return this.http.get<Parameter>(`${this.PARAMETERS_API_URL}/${ParameterName.DASHBOARD_REFRESH_INTERVAL}`)
                    .toPromise()
                    .then(res => {
                      if (res) {
                        this.dashboardRefreshInterval = res.settingValue * 1000;
                        return res.settingValue;
                      }
                      return null;
                    })
                    .catch(err => console.error('ERROR IN PARAMETERS SERVICES => ', err));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/parameters.service.ts